import React, {useContext} from 'react'
import useTranslate from "../../../../modules/local/useTranslate";
import {NullAsDefault} from 'views/Shared'
import _ from "lodash"
import {deepTranslate, shallowDiff} from "../../../Shared";
import {API_ROOT_URL} from "../../../../envs/_current/config";
import {Formik} from "formik";
import {Pure} from "../../../../components/Pure";
import FieldsFactory from "../../../../components/form/FieldsFactory";
import FormActionBar from "../../../../components/form/FormActionBar";
import {createListTransform} from "../../../../apis/utils/createListTransform";
import {baseItemSchema} from "../../../../apis/schema";
import {Input, Radio} from "antd";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import Translate from "../../../../modules/local/Translate";
import {createValue} from "../../../../components/form/utils";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import {appClassNames} from "../../custom/appClassNames";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import image from 'assets/images/words_of_god.webp';
import {LookupTagsPicker} from "../../custom/TagsPicker";
import {createControlledFormField} from "../../factory/createFormField";

const formSchema = {
    content: {
        title: 'content word of god',
        children: [
            {
                name: 'content',
                component: createControlledFormField({
                    rows: 3,
                    placeholder: 'content',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    source_text: {
        title: 'quote from',
        children: [
            {
                name: 'source_text',
                component: createControlledFormField({
                    placeholder: 'St 1, 2-3; Mt 2, 5-6;...',
                }),
            },
        ],
    },
    active: {
        title: 'active',
        children: [

        ],
    },

    language: {
        title: 'language',
        children: [
            {
                name: 'language',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <SelectWidget
                                name={name}
                                value={value}
                                allowClear={true}
                                className="w-full"
                                defaultValue="vi"
                                placeholder={t('language')}
                                onChange={(value) => {
                                    onChange(createValue(name, value ?? null))
                                }}
                                options={[
                                    {label: 'vi', value: 'vi'},
                                    {label: 'en', value: 'en'},
                                ].map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    language_active_group: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'language',
                name: 'language',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <SelectWidget
                                name={name}
                                value={value}
                                allowClear={true}
                                className="w-full"
                                defaultValue="vi"
                                placeholder={t('language')}
                                onChange={(value) => {
                                    onChange(createValue(name, value ?? null))
                                }}
                                options={[
                                    {label: 'vi', value: 'vi'},
                                    {label: 'en', value: 'en'},
                                ].map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'active',
                name: 'active',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="custom-radio-button"
                                options={baseFieldTypes.active.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    hashtags: {
        title: 'topics',
        children: [
            {
                name: 'hashtags',
                component: createControlledFormField({
                    apiInfo: {
                        root: API_ROOT_URL,
                        path: '/lookup/god_word_hashtags/gets',
                        method: 'GET',
                        schema: baseItemSchema,
                        transform: createListTransform(baseItemSchema),
                        paramFields: ['keyword'],
                        fields: ['keyword'],
                    },
                    Component: LookupTagsPicker,
                }),
            },
        ],
    },
}

export const EditGodWordForm = ({
                                  item,
                                  onCancel = NullAsDefault,
                                  onSubmit = NullAsDefault,
                                }) => {

    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const _initialValues = {
        ...item
    }

    const validate = (values) => {
        let errors = {}
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={({...values}) => {
                const changes = shallowDiff(values, _initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <div
                    className="flex flex-center rounded-lg"
                    style={{
                        width: '100%',
                        height: isSm ? 150 : 250,
                        backgroundImage:
                            item?.photo ?
                                'url(' + item?.photo + ')'
                                : `radial-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5)), url(${image})`,
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }}>
                </div>
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.content,
                            formSchema.source_text,
                            formSchema.language_active_group,
                            formSchema.hashtags,
                        ]}
                    />
                </Pure>
                <FormActionBar submitText="save"/>
            </div>
        </Formik>
    )
}

export const CreateGodWordForm = ({
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                  }) => {
  const t = useTranslate()

  const validate = (values) => {
    let errors = {}
    _.forEach(['content', 'source_text', 'language'], (name) => {
      const value = _.get(values, name)
      if (_.isEmpty(value ?? undefined)) {
        errors[name] = t('required field')
      }
    })
    return errors
  }

  return (
    <Formik
      initialValues={{
        language: 'vi',
        content: undefined,
        source_text: undefined,
        hashtags: undefined,
      }}
      validate={validate}
      validateOnMount={true}
      validateOnChange={true}
      enableReinitialize={true}
      onSubmit={(values) => {
        onSubmit(_.omitBy(values, _.isUndefined))
      }}>
      <div className="flex flex-col space-y-2">
        <Pure>
          <FieldsFactory
            formSchema={[
              formSchema.content,
              formSchema.source_text,
              formSchema.language,
              formSchema.hashtags,
            ]}
          />
        </Pure>
        <FormActionBar submitText="create"/>
      </div>
    </Formik>
  )
}
